module.exports = __webpack_public_path__ + "img/gnzx.7d01115.png";